import { InReview, Rejected ,Approved,Draft} from "../styled";

export const backgroundColorHandler = ({ value }) => {
    switch (value) {
      case "REQUESTED":
        return "#EFEFF0";
      case "REJECTED":
        return "#FDDFDB";

      case "CONFIRMED":
        return "white";
      case "DRAFTED":
        return "white";
      default:
        return "white";
    }
  };


  export const Tag = ({ value }) => {
    switch (value) {
      case "REQUESTED":
        return <InReview>Requested</InReview>;
      case "REJECTED":
        return <Rejected>Rejected</Rejected>;
      case "CONFIRMED":
        return <Approved>Confirmed</Approved>;
      case "DRAFTED":
        return <Draft>Draft</Draft>
      default:
        return <></>;
    }
  };


  export const employmentType = (value) => {
    switch (value) {
      case "PART_TIME":
        return "Part Time";
      case "FULL_TIME":
        return "Full Time";
    }
  };


  export const locationType = (value) => {
    switch (value) {
      case "HYBRID":
        return "Hybrid";
      case "REMOTE":
        return "Remote";
    }
  };
